document.body.addEventListener("click", function (e) {
  const openBtn = e.target.closest(".size-chart-btn");
  if (openBtn) {
    const wrapper = openBtn.closest(".size-chart-wrapper");
    const modal = wrapper?.querySelector(".size-chart-modal");

    if (modal) {
      modal.classList.add("is-open");
      document.body.classList.add("modal-open");
    }
    return;
  }

  const closeBtn = e.target.closest(".sizeChart-modal-close");
  if (closeBtn) {
    const modal = closeBtn.closest(".size-chart-modal");
    modal?.classList.remove("is-open");
    document.body.classList.remove("modal-open");
    return;
  }

  if (e.target.classList.contains("size-chart-modal")) {
    e.target.classList.remove("is-open");
    document.body.classList.remove("modal-open");
  }
});
